import md5 from 'crypto-js/md5';

export default (email, options = {}) => {
  const { letterFallback = true, letterValue = '', size = 40 } = options;
  const baseUrl = `https://www.gravatar.com/avatar/${md5(email)}`;

  if (letterFallback) {
    return `${baseUrl}?d=https%3A%2F%2Fui-avatars.com%2Fapi%2F/${encodeURI(
      letterValue || 'Unknown',
    )}&s=${size}`;
  }

  return baseUrl;
};
